module.exports = __webpack_public_path__ + "img/trainings-3.484e8df9.png";